var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowsHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0.2925,4.8725 C0.6825,5.2625 1.3125,5.2625 1.7025,4.8725 L4.1725,2.4025 L6.6425,4.8725 C7.0325,5.2625 7.6625,5.2625 8.0525,4.8725 C8.4425,4.4825 8.4425,3.8525 8.0525,3.4625 L4.8825,0.2925 C4.4925,-0.0975 3.8625,-0.0975 3.4725,0.2925 L0.3025,3.4625 C-0.0975,3.8425 -0.0975,4.4825 0.2925,4.8725 L0.2925,4.8725 Z M8.0525,10.2725 C7.6625,9.8825 7.0325,9.8825 6.6425,10.2725 L4.1725,12.7425 L1.7025,10.2725 C1.3125,9.8825 0.6825,9.8825 0.2925,10.2725 C-0.0975,10.6625 -0.0975,11.3025 0.2925,11.6925 L3.4625,14.8625 C3.8525,15.2525 4.4825,15.2525 4.8725,14.8625 L8.0425,11.6925 C8.4425,11.3025 8.4425,10.6625 8.0525,10.2725 L8.0525,10.2725 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7.827 4.428)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#5697B7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5697B7",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-7.827 -4.428)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowsHover);
export default __webpack_public_path__ + "static/media/icon_arrows_hover.f819b2213f0c271185fa664e58059fdd.svg";
export { ForwardRef as ReactComponent };